// Sorting activities by its sequence
function sortActivitiesBySequence(data) {
  data.data.forEach(datum => {
    if (datum.activities) datum.activities.sort((a, b) => a.sequence - b.sequence)
  })
}

export const state = () => ({
  /**
   * createEventsForm: {}
   * Temporary data for event trigger page,
   * because the action-base list is based on the event form state_date and end_date
   */
  createEventsForm: {},
  selectedLanguageTab: 0, // It's for create form, and will be used to display the name of the activity name; Because it will share between components
  missions: {},
  mission: {},
  missionsDetail: {},
  missionActivities: [],
  missionActivitiesCache: {},
  basicSetting: {
    coin_name: {},
    extra_coins: null,
    file: null,
    mission_layout: null,
    reset_coin_status: null
  },
  activitiesList: [],
  overlapDates: { 1: [], 2: [], 3: [], 4: [] },
  overlapDateLoading: false,
  cancelToken: {}
})

export const actions = {
  async getMissionControls({ commit }, params) {
    await this.$axios
      .get(`/players-reward/mission-control/missions`, { params })
      .then(data => {
        commit('setMissions', {
          [params.mission_type]: data.data?.missions
        })
        return data.data
      })
      .catch(_ => {
        return false
      })
  },
  async getMissionControlsById({ commit }, params) {
    const response = await this.$axios
      .get(`/players-reward/mission-control/missions/activities`, {
        params: {
          mission_id: params
        }
      })
      .then(data => {
        sortActivitiesBySequence(data.data)
        commit('setMissionControlDetailById', {
          [params]: data?.data?.data
        })
        return data.data
      })
      .catch(_ => {
        return false
      })
    return response
  },
  async getBasicSetting({ commit }, params) {
    await this.$axios
      .get(`/players-reward/mission-control/basic-settings`, {
        params
      })
      .then(data => {
        commit('setBasicSetting', data.data)
        return true
      })
      .catch(_ => {
        return false
      })
  },
  async updateBasicSetting({ _ }, body) {
    const response = await this.$axios
      .put(`/players-reward/mission-control/basic-settings`, body, {
        params: {}
      })
      .then(data => {
        return data.data
      })
      .catch(_ => {
        return false
      })
    return response
  },
  async updateActivityStatus({ _ }, body) {
    const response = await this.$axios
      .put(`/players-reward/mission-control/mission-type/status`, body, {
        params: {}
      })
      .then(data => {
        return data.data
      })
      .catch(_ => {
        return false
      })
    return response
  },
  async createMissionControl({ commit }, body) {
    const response = await this.$axios
      .post('/players-reward/mission-control/missions', body, {
        params: { hideToast: true }
      })
      .then(data => {
        commit('setMission', data.data)
        return data.data
      })
      .catch(_ => {
        return false
      })

    return response
  },
  async getMissionById({ commit }, id) {
    await this.$axios
      .get(`/players-reward/mission-control/missions/${id}`)
      .then(data => {
        commit('setMission', data.data)
        return data.data
      })
      .catch(_ => {
        return false
      })
  },
  async deleteMissionById({ _ }, id) {
    const response = await this.$axios
      .delete(`/players-reward/mission-control/missions/${id}`)
      .then(data => {
        return data.data
      })
      .catch(_ => {
        return false
      })
    return response
  },
  async createMissionActivity({ _ }, body) {
    const response = await this.$axios
      .post(`/players-reward/mission-control/missions/activity`, body)
      .then(data => {
        return data.data
      })
      .catch(_ => {
        return false
      })
    return response
  },
  async getActivitiesByMissionId({ commit, state }, missionId) {
    if (state.cancelToken.getActivitiesByMissionId) {
      state.cancelToken.getActivitiesByMissionId.cancel('')
    }

    const cancelToken = this.$axios.CancelToken.source()
    commit('setCancelToken', { getActivitiesByMissionId: cancelToken })

    const response = await this.$axios
      .get(`/players-reward/mission-control/missions/activities`, {
        params: {
          mission_id: missionId
        },
        cancelToken: cancelToken.token
      })
      .then(data => {
        sortActivitiesBySequence(data.data)
        commit('setMissionActivities', data.data?.data)
        commit('setMissionControlDetailById', {
          [missionId]: data?.data?.data
        })
        return data.data
      })
      .catch(_ => {
        return false
      })
    return response
  },
  async getActivitiesByMissionIdAndDate({ commit, state }, { missionId, activityDate }) {
    const cacheKey = `${missionId}-${activityDate}`
    if (state.missionActivitiesCache[cacheKey]) return state.missionActivitiesCache[cacheKey]

    const response = await this.$axios
      .get(`/players-reward/mission-control/missions/day/activities`, {
        params: {
          mission_id: missionId,
          date: activityDate
        }
      })
      .then(data => {
        const sortedData = data.data?.data?.sort((a, b) => a.sequence - b.sequence)
        commit('setMissionActivitiesCache', {
          key: cacheKey,
          data: sortedData
        })
        return sortedData
      })
      .catch(_ => {
        return false
      })
    return response
  },
  async updateMissionControl({ _ }, { id, body }) {
    const response = await this.$axios
      .put(`/players-reward/mission-control/missions/${id}`, body, {
        params: {
          hideToast: true
        }
      })
      .then(data => {
        return data.data
      })
      .catch(_ => {
        return false
      })
    return response
  },
  async getActivitiesList({ commit, state }, params) {
    if (state.activitiesList.length > 0) {
      return state.activitiesList
    }
    const response = await this.$axios
      .get(`/players-reward/mission-control/activities-list`, { params })
      .then(data => {
        commit('setActivitiesList', data.data)
        return data.data
      })
      .catch(_ => {
        return false
      })
    return response
  },
  async cloneMissionControl({ _ }, body) {
    const response = await this.$axios
      .post(`/players-reward/mission-control/missions/clone`, body)
      .then(data => {
        return data.data
      })
      .catch(_ => {
        return false
      })
    return response
  },
  async deleteMissionActivity({ _ }, activityId) {
    const response = await this.$axios
      .delete(`/players-reward/mission-control/missions/activity/${activityId}`)
      .then(data => {
        return data.data
      })
      .catch(_ => {
        return false
      })
    return response
  },
  async uploadImage({ commit }, body) {
    const response = await this.$axios
      .post(`/file-upload`, body)
      .then(response => {
        return response.data
      })
      .catch(() => false)
    return response
  },
  async getOverlapDates({ commit, state }, params) {
    if (state.cancelToken.getOverlapDates) {
      state.cancelToken.getOverlapDates.cancel('')
    }

    const cancelToken = this.$axios.CancelToken.source()
    commit('setCancelToken', { getOverlapDates: cancelToken })

    commit('setOverlapDateLoading', true)
    const response = await this.$axios
      .get(`/players-reward/mission-control/missions/closed-dates`, {
        params,
        cancelToken: cancelToken.token
      })
      .then(data => {
        commit('setOverlapDates', { [params.mission_type]: data.data })
        return data.data
      })
      .catch(_ => {
        return false
      })
    commit('setOverlapDateLoading', false)
    return response
  }
}

export const mutations = {
  setCreateEventsForm(state, data) {
    state.createEventsForm = data
  },
  setMission(state, data) {
    state.mission = data
  },
  setMissions(state, data) {
    const existingData = JSON.parse(JSON.stringify(state.missions))
    const newMission = {
      ...existingData,
      ...data
    }
    state.missions = newMission
  },
  setMissionControlDetailById(state, data) {
    const existingData = JSON.parse(JSON.stringify(state.missionsDetail))
    const newMission = {
      ...existingData,
      ...data
    }
    state.missionsDetail = newMission
  },
  setBasicSetting(state, data) {
    state.basicSetting = data
  },
  setMissionActivities(state, data) {
    state.missionActivities = data
  },
  setMissionActivitiesCache(state, data) {
    state.missionActivitiesCache = {
      ...state.missionActivitiesCache,
      [data.key]: data.data
    }
  },
  setRemoveMissionActivitiesCache(state, key) {
    const newCache = { ...state.missionActivitiesCache }
    delete newCache[key]
    state.missionActivitiesCache = newCache
  },
  setSelectedLanguageTab(state, data) {
    state.selectedLanguageTab = data
  },
  setActivitiesList(state, data) {
    state.activitiesList = data
  },
  setOverlapDates(state, data) {
    const newData = { ...state.overlapDates, ...data }
    state.overlapDates = newData
  },
  setCancelToken(state, data) {
    const oldData = { ...state.cancelToken }
    state.cancelToken = {
      ...oldData,
      ...data
    }
  },
  setOverlapDateLoading(state, data) {
    state.overlapDateLoading = data
  }
}

export const getters = {
  occupiedWeeklyDates: state => missionType => {
    return state.missions[missionType].map(mission => ({
      startDate: mission.start_date,
      endDate: mission.end_date
    }))
  }
}
